import style from "./TableQuotations.module.scss"

const { quotationStatus, inProgress, submitted } = style

type Props = { status: string }

export const TableQuotationsStatuses = ({ status }: Props) => {
	switch (status) {
		case "in_progress":
			return <div className={`${quotationStatus} ${inProgress}`}>In progress</div>

		case "submitted":
			return <div className={`${quotationStatus} ${submitted}`}>Submitted</div>

		default:
			return ""
	}
}
